import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { Col } from "reactstrap";
import { ErrorMessage } from "../../../../../utils/ErrorMessage";
import { selectInputStyle } from "../../../../../utils/SelectInputStyles";
import InputField from "../../../inputs/InputField";
import MobileNoInputField from "../../../inputs/MobileNoInputField";
import { toastMessage } from "../../../../commonFunctions";
import { CustomerDetailsFormSchema } from "../FormComponentSchema";
import useLocationApi from "../../../../../hooks/useLocationApi";
import { CountryListAaray, CountryLists } from "../../../../../pages/Contact/EditContact/EditContactSchema";
import { useSelector } from "react-redux";

const TransporterDetailForm  : React.FC<CustomerDetailsFormSchema> = ({
  accountGroupArr,
  // accountGrpDefaultValue,
  paymentTermArr,
  register,
  errors,
  control,
  newContactCreatedDetail,
  handleBlurFirstName,
  handleBlurLastName,
  handleBlurCompanyName,
  handleBlurCreditAmount,
  handleBlurDebitAmount,
  setValue,
}) => {
  const { getCountryList } = useLocationApi();
  const sessionList = useSelector((state: any) => state.sessionData.sessionScope);
  const taxtype = sessionList?.governmentTaxType || "gst";
  // const taxtype = sessionList?.governmentTaxType || "gst";
  
  const [countryCodeImg, setCountryCodeImg] = useState<CountryLists[]>([]); 
  const accountGroupArrs = accountGroupArr.map(({ label, value }) => ({
    label,
    value: value.toString(),  
  }));


  
  


  useEffect(() => {
    const fetchCountryList = async () => {
      try {
        const countryList = await getCountryList();
  
        if (countryList) {
          const parsedResult = CountryListAaray.safeParse(countryList?.response);
          if (parsedResult.success) {
            setCountryCodeImg(parsedResult.data);
          } else {
            console.error("Parsing error:", parsedResult.error.format());
          }
        } else {
          console.error("Response data is null or undefined.");
        }
      } catch (error) {
        console.error("Error fetching country list:", error);
      }
    };
  

      fetchCountryList();

  }, [newContactCreatedDetail]);

        
  return (
    <>
      <div className="form-container">
        <Col md={"auto"}>
          <InputField
            labelName="Frist Name"
            placeholder="First Name"
            name="firstName"
            register={register}
            onChange={handleBlurFirstName}
            required
            errorMessage={ErrorMessage(errors?.firstName?.message)}
          />
        </Col>

        <Col>
          <InputField
            
            labelName="Last Name"
            placeholder="Last Name"
            name="lastName"
            onChange={handleBlurLastName}
            register={register}
            errorMessage={ErrorMessage(errors?.lastName?.message)}
          />
        </Col>

        <Col md={"auto"}>
          <InputField
           
            labelName="Company Name"
            placeholder="Company Name"
            name="companyName"
            onChange={handleBlurCompanyName}
            // onChange={handleBlurCompanyName}
            register={register}
            required
            errorMessage={ErrorMessage(errors?.companyName?.message)}
          />
        </Col>

        <Col>
          <InputField
           
            labelName="PAN No."
            placeholder="PAN No."
            name="panNo"
            register={register}
            errorMessage={ErrorMessage(errors?.panNo?.message)}
          />
        </Col>

        <Col>
          <InputField
           
            labelName="Transporter ID"
            placeholder="Transporter ID"
            name="transporterId"
            register={register}
            errorMessage={ErrorMessage(errors?.transporterId?.message)}
          />
        </Col>
      </div>

      <div className="form-container">
        <Col md={"auto"}>
          <MobileNoInputField
            newContactCreatedDetail={newContactCreatedDetail}
            inputName="mobNo"
            labelName="Mobile No."
            name="mobNo"
            control={control}
            placeHolder={"Mobile No."}
            setValue={setValue}
            countryCodeImg={countryCodeImg}
          />
          {ErrorMessage(errors?.mobNo?.message)}
        </Col>

        <Col>
          <InputField
           
            labelName="Telephone No."
            placeholder="Telephone No."
            name="telephone"
            register={register}
            inputType="number"
            onKeyDown={(evt) =>
              ["e", "E", "+", "-", "."].includes(evt.key) &&
              evt.preventDefault()
            }
            errorMessage={ErrorMessage(errors?.telephone?.message)}
          />
        </Col>

        <Col>
          <InputField
           
            labelName="Email"
            placeholder="Email"
            name="email"
            register={register}
            errorMessage={ErrorMessage(errors?.email?.message)}
          />
        </Col>

        <Col md={5} className="pr-3">
          <label style={{ fontWeight: 600 }}>Account Group</label>
          <Controller
            name={"accountGroupId"}
            control={control}
            render={({ field }) => (
              <Select
                styles={{
                  ...selectInputStyle,
                  control: (baseStyles) => ({ 
                    ...baseStyles,
                     width: "100%" , 
                     borderColor: '#ebedf2',
                      borderRadius: '5px',
                      minHeight: '30.76px',
                      height: '30.76px',
                  }),
                }}
                options={accountGroupArrs}
                menuPortalTarget={document.body}
                {...field}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption);
                }}
              />
            )}
          />
        </Col>
      </div>

      <div className="form-container mt-3">
        <Col md={"auto"}>
          <InputField
           
            labelName="Date Of Birth"
            placeholder="Date Of Birth"
            name="dateOfBirth1"
            inputType="date"
            onChange={(e) => {
             
              const selectedDate = new Date(e.target.value);
              const today = new Date();
            
              // Convert both dates to YYYY-MM-DD format to avoid timezone issues
              const selectedDateString = selectedDate.toISOString().split("T")[0];
              const todayString = today.toISOString().split("T")[0] || "";
              // console.log(selectedDateString, todayString);
              if (selectedDateString && selectedDateString > todayString) {
                
                e.target.value = ""; 
                toastMessage("The selected date cannot be in the future. Please choose a valid date.");
              }
            }}
            register={register}
          />
        </Col>
        <Col>
          <InputField
           
            labelName="Anniversary Date"
            placeholder="Anniversary Date"
            name="anniversaryDate1"
            inputType="date"
            onChange={(e) => {
              const selectedDate = new Date(e.target.value);
              const today = new Date();

              // Reset the time component of today
              today.setHours(0, 0, 0, 0);
              // Reset the time component of the selected date to midnight
              selectedDate.setHours(0, 0, 0, 0);
              //  console.log(selectedDate, today);
              if (selectedDate > today) {
                // Reset the input field or show an error message
                e.target.value = ""; // Optional: Clear the input if the date is invalid
                toastMessage(
                  "The selected date cannot be in the future. Please choose a valid date"
                );
              }
            }}
            register={register}
          />
        </Col>
        {window.location.href.includes("/new") && (
          <>
            <Col>
              <InputField
               
                labelName="Opening Balance"
                placeholder="Debit Amount"
                name="debitAmount"
                register={register}
                inputType="number"
                onKeyDown={(evt) =>
                  ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
                }
                onBlur={handleBlurDebitAmount}
                errorMessage={ErrorMessage(errors?.debitAmount?.message)}
              />
            </Col>

            <Col md={"auto"}>
              <InputField
               
                onBlur={handleBlurCreditAmount}
                labelName="Credit Amount"
                hiddenLabel={true}
                placeholder="Credit Amount"
                name="creditAmount"
                register={register}
                onKeyDown={(evt) =>
                  ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
                }
                inputType="number"
                errorMessage={ErrorMessage(errors?.creditAmount?.message)}
              />
            </Col>
          </>
        )}

        <Col>
          <label style={{ fontWeight: 600 }}>Payment Terms</label>
          <Controller
            name={"paymentTermId"}
            control={control}
            render={({ field }) => (
              <Select
                placeholder={"Select Payment Terms"}
                styles={selectInputStyle}
                options={paymentTermArr}
                menuPortalTarget={document.body}
                {...field}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption);
                }}
              />
            )}
          />
        </Col>
      </div>

      <div className="form-container mt-3">
         {
          taxtype == "vat" && (
            <Col>
            <InputField
              labelName="VAT No."
              placeholder="VAT No"
              name="vatNo"
              id="vatNo"
              register={register}
              errorMessage={ErrorMessage(errors?.vatNo?.message)}
            />
          </Col>
          )
        }
        <Col>
          <InputField
           
            labelName="Remarks"
            placeholder="Remarks"
            name="remark"
            register={register}
            errorMessage={ErrorMessage(errors?.remark?.message)}
          />
        </Col>
      
      </div>
    </>
  );
};

export default TransporterDetailForm;
